module.exports = "<div class=\"form-box form-response\">\r\n  <div class=\"info-item form-response\">\r\n    <div class=\"info-item-heading\">{{formFieldResponse.model.field.title}}</div>\r\n    <!--TODO: convert to pluralization translation-->\r\n    <div class=\"\">\r\n      {{formFieldResponse.model.response.result.value}}\r\n      {{formFieldResponse.model.response.result.value ? ' ' + formFieldResponse.model.response.result.unit : ''}}\r\n    </div>\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/forms/directives/field-templates/duration/response-view.html
// module id = 3437
// module chunks = 0